import React from "react"
import { twMerge } from "tailwind-merge"

export const UnderlinedLink = ({ children, className, ...rest }) => (
  <a {...rest} className={twMerge("cursor-pointer font-bold text-teal underline", className)}>
    {children}
  </a>
)

export const Link = ({ children, className, ...rest }) => (
  <a {...rest} className={twMerge("cursor-pointer text-teal hover:underline", className)}>
    {children}
  </a>
)

export const TabNavLink = ({ children, className, active, ...rest }) => {
  const activeClass = active ? "text-black font-bold" : ""
  return (
    <a {...rest} className={twMerge("inline-flex w-fit flex-col gap-2 text-teal", activeClass, className)}>
      <span>{children}</span>
      {active && <div className="h-0.5 w-full bg-black" />}
    </a>
  )
}

export const ButtonLink = ({ children, className, variant = "primary", ...rest }) => (
  <a
    {...rest}
    className={twMerge(
      "inline-flex h-8 shrink-0 items-center justify-center rounded px-4 text-sm font-bold leading-none focus:outline-none focus:ring-2 focus:ring-blue",
      variant === "secondary"
        ? "border border-teal bg-white text-teal active:bg-gray-light"
        : variant === "link"
        ? "h-auto border-none bg-transparent p-0 font-normal text-teal underline hover:shadow-none"
        : "border border-teal bg-teal text-white hover:shadow active:bg-teal-dark",
      className
    )}>
    {children}
  </a>
)
